export default passwordVisibility => {
    console.log('passwordVisibility');

    const inputPassword = passwordVisibility.parentNode.querySelector('.input.password') || passwordVisibility.parentNode.querySelector('.fr-input.password');

    function togglePaswordVisibility() {
        if (inputPassword.type !== 'text') {
            inputPassword.type = 'text';
            passwordVisibility.querySelector('.icon').classList.remove('fr-fi-eye-line');
            passwordVisibility.querySelector('.icon').classList.add('fr-fi-eye-off-line');
            passwordVisibility.querySelector('.sr-only').textContent = 'Masquer le mot de passe';
        } else {
            inputPassword.type = 'password';
            passwordVisibility.querySelector('.icon').classList.remove('fr-fi-eye-off-line');
            passwordVisibility.querySelector('.icon').classList.add('fr-fi-eye-line');
            passwordVisibility.querySelector('.sr-only').textContent = 'Afficher le mot de passe';
        }
    }

    passwordVisibility.addEventListener('click', togglePaswordVisibility);
};
